import Vue from 'vue'
import Vuex from 'vuex'
import { format } from 'date-fns'
import {
  INDEX,
  ARTICLE
} from './type_mutation'
import urls from '../server/url'

Vue.use(Vuex);

const switchUser = {
  "ORDINARY": "普通用户",
  "MEDIA": "媒体用户",
  "SUPER": "超级用户"
}
export default new Vuex.Store({
  state: {
    videoClubs: [],
    hotClubs: [

    ],
    focusPosts: [],
    loading: true,
    currentIndex: 1,
    currentTr: 1,
    transition1: true,
    transition2: false,
    transition2Level2: false,
    transition3: false,

    // 帖子
    postInfo: {},
    postComment: [],
    userInfo: {},
    userPosts: [],

    // localstore
    vlfArticle: null,

    total: 0,
    count: 200,
    page: 1
  },
  actions: {
    [INDEX.INDEX_AXIOS_VIDEO_CLUB.actions_type]() {
      return new Promise((resolve, rejects) => {
        window.axios.get(urls.videoClub, {
          responseType: 'json',
          params: {
            page: 0,
            count: 5
          }
        }).then(res => {
          resolve(res.data)
        }).catch(error => {
          rejects(error)
        })
      })
    },
    [INDEX.INDEX_AXIOS_HOT_CLUB.actions_type]({ commit }, payload) {
      return new Promise((resolve, rejects) => {
        window.axios.post(urls.hotClubs, {
          responseType: 'json',
          pageNum: 200,
        }).then(res => {
          window.console.log('res', res, payload.flag)
          // if (payload.flag) {
          // commit(INDEX.INDEX_SAVE_DATA.mutations_type, { hotClubs: formatHotClubs(res.data.body.content) })
          commit(INDEX.INDEX_SAVE_DATA.mutations_type, { hotClubs: res.data.elements })
          // }
          resolve(res.data)
        }).catch(error => {
          rejects(error)
        })
      })
    },
    [INDEX.INDEX_AXIOS_FOCUS_POST.actions_type]() {
      return new Promise((resolve, rejects) => {
        window.axios.get(urls.focusPosts, {
          responseType: 'json',
          params: {
            page: 0,
            count: 12,
            simplePost: true
          }
        }).then(res => {
          resolve(res.data)
        }).catch(error => {
          rejects(error)
        })
      })
    },
    async [INDEX.INDEX_AXIOS_GET.actions_type]({
      dispatch,
      commit
    }) {
      // const videoClubs = await dispatch(INDEX.INDEX_AXIOS_VIDEO_CLUB.actions_type)
      const hotClubs = await dispatch(INDEX.INDEX_AXIOS_HOT_CLUB.actions_type, { page: 1, count: 200 })
      // const focusPosts = await dispatch(INDEX.INDEX_AXIOS_FOCUS_POST.actions_type)

      await commit(INDEX.INDEX_AXIOS_GET.mutations_type, {
        // videoClubs,
        hotClubs,
        // focusPosts
      });
    },

    // 帖子
    [ARTICLE.ARTICLE_POST_INFO.actions_type](context, id) {
      return new Promise((resolve, rejects) => {
        window.axios.get(urls.postInfo(id), {
          responseType: 'json'
        }).then(res => {
          resolve(res.data)
        }).catch(error => {
          rejects(error)
        })
      })
    },
    [ARTICLE.ARTICLE_POST_COMMENT.actions_type](context, id) {
      return new Promise((resolve, rejects) => {
        window.axios.get(urls.postComments(id), {
          responseType: 'json',
          params: {
            page: 0,
            count: 2,
          }
        }).then(res => {
          resolve(res.data)
        }).catch(error => {
          rejects(error)
        })
      })
    },
    [ARTICLE.ARTICLE_USER_INFO.actions_type](context, id) {
      return new Promise((resolve, rejects) => {
        window.axios.get(urls.userInfo(id), {
          responseType: 'json'
        }).then(res => {
          resolve(res.data)
        }).catch(error => {
          rejects(error)
        })
      })
    },
    [ARTICLE.ARTICLE_USER_POST.actions_type](context, id) {
      return new Promise((resolve, rejects) => {
        window.axios.get(urls.userPosts(id), {
          responseType: 'json',
          params: {
            page: 0,
            count: 3
          }
        }).then(res => {
          resolve(res.data)
        }).catch(error => {
          rejects(error)
        })
      })
    },
    async [ARTICLE.ARTICLE_AXIOS_GET.actions_type]({
      dispatch,
      commit
    }, opt) {
      const {
        postId,
        vlf
      } = opt;
      const postInfo = await dispatch(ARTICLE.ARTICLE_POST_INFO.actions_type, postId)
      const postComment = await dispatch(ARTICLE.ARTICLE_POST_COMMENT.actions_type, postId)
      const userInfo = await dispatch(ARTICLE.ARTICLE_USER_INFO.actions_type, postInfo.body.userId)
      const userPosts = await dispatch(ARTICLE.ARTICLE_USER_POST.actions_type, postInfo.body.userId)
      await commit(ARTICLE.ARTICLE_AXIOS_GET.mutations_type, {
        postInfo,
        postComment,
        userInfo,
        userPosts,
        vlf
      });
    },
    [INDEX.INDEX_SAVE_DATA.actions_type]({
      commit
    }, payload) {
      commit(INDEX.INDEX_SAVE_DATA.mutations_type, payload)
    }
  },
  mutations: {
    [INDEX.INDEX_AXIOS_GET.mutations_type](state, data) {
      const { videoClubs, hotClubs, focusPosts } = data;
      state.videoClubs = videoClubs.code === 0 ? videoClubs.body : [];
      state.hotClubs = hotClubs.code === 0 ? hotClubs.body.content : []
      state.total = hotClubs.body.totals;
      state.focusPosts = focusPosts.code === 0 ? focusPosts.body.feeds.filter(o => o.feedType === "POST") : []
      state.loading = false
    },
    // 帖子
    async [ARTICLE.ARTICLE_AXIOS_GET.mutations_type](state, data) {
      const {
        vlf
      } = data;

      if (data.postInfo.code === 0) {
        const body = data.postInfo.body;
        const title = body.postType === "LONGTEXT" ? body.contents[0]["content"] : body.contents.filter(item => item.type === "TEXT")[0]["content"];
        const summary = body.postType === "LONGTEXT" ? body.contents.filter(item => item.type === "SUMMARY")[0]["content"] : body.contents.filter(item => item.type === "TEXT")[0]["content"];
        const newData = {
          title,
          summary,
          createTime: format(new Date(body.createAt), "YYYY/MM/DD"),
          contents: body.contents.filter(item => item.type !== "TITLE")
        }
        state.postInfo = newData
        vlf.setItem("postInfo", newData);
      }
      if (data.postComment.code === 0) {
        const cs = data.postComment.body.map(item => {
          const t = item.contents.filter(o => o.type === "TEXT");
          const i = item.contents.filter(o => o.type === "IMAGE");
          return {
            nickname: item.nickname,
            avatar: item.avatar,
            t,
            i
          }
        })
        state.postComment = cs;
        vlf.setItem("postComment", cs);
      }
      if (data.userInfo.code === 0) {
        const newData = {
          nickname: data.userInfo.body.nickname,
          avatar: data.userInfo.body.avatar,
          title: data.userInfo.body.title,
          identity: switchUser[data.userInfo.body.identity]
        }
        state.userInfo = newData;
        vlf.setItem("userInfo", newData);
      }
      if (data.userPosts.code === 0) {
        const up = data.userPosts.body.map(item => {
          const title = item.postType === "LONGTEXT" ? item.contents[0]["content"] : item.contents.filter(item => item.type === "TEXT")[0]["content"];
          let cover = "";
          if (item.postType === "LONGTEXT") {
            cover = item.contents.filter(item => item.type === "COVER")[0]["content"];
          }
          if (item.postType === "TEXT") {
            cover = item.contents.filter(item => item.type === "IMAGE")[0]["content"];
          }
          if (item.postType === "VIDEO") {
            const it = item.contents.filter(item => item.type === "VIDEO")[0];
            cover = JSON.parse(it.extra)["cover"]
          }
          return {
            title,
            cover,
            createTime: format(new Date(item.createAt), "YYYY/MM/DD"),
            postId: item.postId
          }
        })
        state.userPosts = up;
        vlf.setItem("userPosts", up);
      }
      vlf.setItem("articleFlag", true)
    },
    [INDEX.INDEX_SAVE_DATA.mutations_type](state, data) {
      const keys = Object.keys(data)
      for (let len = keys.length, i = 0; i < len; i++) {
        state[keys[i]] = data[keys[i]];
      }
    }
  }
})

// function formatHotClubs(clubs) {
//   const len = clubs.length;
//   const n = 6;
//   const lineNum = len % n === 0 ? len / n : Math.floor((len / n) + 1);
//   let res = [];
//   for (let i = 0; i < lineNum; i++) {
//     let temp = clubs.slice(i * n, i * n + n);
//     res.push(temp);
//   }
//   return res;
// }